/* unplugin-vue-components disabled */import { render } from "./detailsProductContent.vue?vue&type=template&id=1adb1b9f&scoped=true"
import script from "./detailsProductContent.vue?vue&type=script&lang=js"
export * from "./detailsProductContent.vue?vue&type=script&lang=js"

import "./detailsProductContent.vue?vue&type=style&index=0&id=1adb1b9f&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adb1b9f"]])

export default __exports__